// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  confirmColumn: {
    padding: theme.spacing(2),
  },
  pageTitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    fontWeight: 400,
    fontSize: '28px',
  },
  confirmText: {
    fontWeight: 400,
    marginBottom: theme.spacing(4),
  },
  sectionTitle: {
    marginBottom: theme.spacing(1),
    textTransform: 'capitalize',
  },
  subSectionTitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  section: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    marginTop: theme.spacing(2),
  },
  button: {
    padding: 0,
    justifyContent: 'flex-end',
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
  cardWrapper: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    gridColumnGap: theme.spacing(2),
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    alignItems: 'center',
    width: '100%',
    textAlign: 'left',
    border: '1px solid transparent',
  },
  iconWrapper: {
    width: theme.spacing(4),
  },
  defaultCard: {
    borderColor: theme.palette.primary.main,
  },
  header: {
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  deliverableList: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    alignItems: 'center',
    justifySelf: 'left',
    '&>*:nth-child(2n)': {
      textAlign: 'right',
      justifySelf: 'right',
      marginLeft: theme.spacing(1),
    },
  },
  emailTag: {
    color: theme.palette.primary.main,
  },
  errorIcon: {
    marginLeft: '15px',
    height: '20px',
    width: '30px',
    color: theme.palette.primary.main,
    float: 'left',
  },
  outputConfidenceBorder: {
    borderStyle: 'solid',
    padding: '10px 0',
    borderColor: '#7DD5D8',
    marginBottom: theme.spacing(1),
    borderWidth: '1px',
  },
  outputConfidence: {
    textAlign: 'left',
    paddingLeft: '55px',
    fontWeight: 400,
    fontSize: '15px',
  },
  anchorTag: {
    color: '#7DD5D8',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  textField: {
    border: 'solid 1px #EAEAEA',
    padding: theme.spacing(1),
  },
  saveLayerSelection: {
    display: 'flex',
    alignItems: 'center',
    margin: '30px 0',
    color: theme.palette.primary.main,
    gap: '5px',
    cursor: 'pointer',
  },
  saveLayerSelectionHidden: {
    display: 'none',
  },
  bundleName: {
    color: theme.palette.primary.main,
  },
  extraDeliverablesName: {
    marginRight: theme.spacing(1),
  },
  extraLayersName: {
    marginRight: theme.spacing(1),
  },
});

export default styles;
